// Однократная ленивая загрузка jQuery + bootstrap-datepicker + ru-локали.
// Общий для month-picker (выбор месяца) и datepicker (выбор дня) контроллеров,
// чтобы не дублировать логику и держать единую копию jQuery в сборке.
//
// jQuery один на всю сборку (esbuild --alias:jquery): та же копия, что цепляет
// bootstrap-datepicker через require('jquery'). Без alias у плагина была бы
// вложенная копия node_modules/bootstrap-datepicker/node_modules/jquery и
// $.fn.datepicker оставался бы undefined.
//
// Статические import-ы хойстятся, поэтому порядок (window.$ до плагина)
// гарантируем именно динамической загрузкой.
let datepickerPromise = null

export function ensureDatepicker() {
  datepickerPromise ||= (async () => {
    const jquery = (await import("jquery")).default
    window.$ = window.jQuery = jquery
    await import("bootstrap-datepicker")
    jquery.fn.datepicker.dates.ru = {
      days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
      daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
      daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
      monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
      today: "Сегодня",
      clear: "Очистить",
      format: "dd.mm.yyyy",
      weekStart: 1,
      monthsTitle: "Месяцы"
    }
    return jquery
  })()
  return datepickerPromise
}
